/* eslint-disable max-len */
import React from 'react';

const Slideshow = props => (
  <svg width={19} height={19} {...props}>
    <path
      fill="currentColor"
      d="M2 4v11h15V4H2zm0-1h15c.552 0 1 .582 1 1.3v10.4c0 .718-.448 1.3-1 1.3H2c-.552 0-1-.582-1-1.3V4.3C1 3.582 1.448 3 2 3zm2 6v1h1V9H4zm1-1v1h1V8H5zm0 2v1h1v-1H5zm9-1v1h1V9h-1zm-1-1v1h1V8h-1zm0 2v1h1v-1h-1z"
    />
  </svg>
);

export default Slideshow;
